/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VocRouteImport } from './routes/voc'
import { Route as OutputRouteImport } from './routes/output'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ItemIncidentRouteImport } from './routes/item-incident'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ItemIncidentRowNumberRouteImport } from './routes/item-incident_.$rowNumber'

const VocRoute = VocRouteImport.update({
  id: '/voc',
  path: '/voc',
  getParentRoute: () => rootRouteImport,
} as any)
const OutputRoute = OutputRouteImport.update({
  id: '/output',
  path: '/output',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ItemIncidentRoute = ItemIncidentRouteImport.update({
  id: '/item-incident',
  path: '/item-incident',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ItemIncidentRowNumberRoute = ItemIncidentRowNumberRouteImport.update({
  id: '/item-incident_/$rowNumber',
  path: '/item-incident/$rowNumber',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/item-incident': typeof ItemIncidentRoute
  '/login': typeof LoginRoute
  '/output': typeof OutputRoute
  '/voc': typeof VocRoute
  '/item-incident/$rowNumber': typeof ItemIncidentRowNumberRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/item-incident': typeof ItemIncidentRoute
  '/login': typeof LoginRoute
  '/output': typeof OutputRoute
  '/voc': typeof VocRoute
  '/item-incident/$rowNumber': typeof ItemIncidentRowNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/item-incident': typeof ItemIncidentRoute
  '/login': typeof LoginRoute
  '/output': typeof OutputRoute
  '/voc': typeof VocRoute
  '/item-incident_/$rowNumber': typeof ItemIncidentRowNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/item-incident'
    | '/login'
    | '/output'
    | '/voc'
    | '/item-incident/$rowNumber'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/item-incident'
    | '/login'
    | '/output'
    | '/voc'
    | '/item-incident/$rowNumber'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/item-incident'
    | '/login'
    | '/output'
    | '/voc'
    | '/item-incident_/$rowNumber'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  ItemIncidentRoute: typeof ItemIncidentRoute
  LoginRoute: typeof LoginRoute
  OutputRoute: typeof OutputRoute
  VocRoute: typeof VocRoute
  ItemIncidentRowNumberRoute: typeof ItemIncidentRowNumberRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/voc': {
      id: '/voc'
      path: '/voc'
      fullPath: '/voc'
      preLoaderRoute: typeof VocRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/output': {
      id: '/output'
      path: '/output'
      fullPath: '/output'
      preLoaderRoute: typeof OutputRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/item-incident': {
      id: '/item-incident'
      path: '/item-incident'
      fullPath: '/item-incident'
      preLoaderRoute: typeof ItemIncidentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/item-incident_/$rowNumber': {
      id: '/item-incident_/$rowNumber'
      path: '/item-incident/$rowNumber'
      fullPath: '/item-incident/$rowNumber'
      preLoaderRoute: typeof ItemIncidentRowNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  ItemIncidentRoute: ItemIncidentRoute,
  LoginRoute: LoginRoute,
  OutputRoute: OutputRoute,
  VocRoute: VocRoute,
  ItemIncidentRowNumberRoute: ItemIncidentRowNumberRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
